import { render, staticRenderFns } from "./StockReplenishmentCommodity.vue?vue&type=template&id=19572667&"
import script from "./StockReplenishmentCommodity.vue?vue&type=script&lang=ts&"
export * from "./StockReplenishmentCommodity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports